import React from "react"
import {Navigate, useLocation} from "react-router-dom"
import {Result} from "antd"
import {useAccessPolicy, isPathAllowed} from "."
import Loading from "../../components/loading/Loading"
import {translateUi} from "../../i18n/translateUi"

interface AccessGuardProps {
    children: React.ReactNode
    fallbackTo?: string
    mode?: "redirect" | "result"
}

const AccessGuard: React.FC<AccessGuardProps> = ({children, fallbackTo = "/", mode = "redirect"}) => {
    const location = useLocation()
    const policy = useAccessPolicy()

    if (policy.isLoading) {
        return <Loading />
    }

    if (isPathAllowed(location.pathname, policy)) {
        return <>{children}</>
    }

    if (mode === "result" || location.pathname === fallbackTo) {
        return <Result status="403" title={translateUi("Нет доступа")} subTitle={translateUi("Для этого аккаунта раздел временно недоступен.")} />
    }

    return <Navigate to={fallbackTo} replace />
}

export default AccessGuard
